import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import styles from './header.module.scss';
import useTranslation from "next-translate/useTranslation";
import { personalBookAccess } from "../../../api/requests";
import Carousel from 'react-elastic-carousel';
import MyWordsBook from "../../profile/myWordsBook";
import { useRouter } from 'next/router';

var Header = function Header(_ref) {
  var totalUsersNumber = _ref.totalUsersNumber,
      setShow2 = _ref.setShow2;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var isRTL = lang === 'farsi';

  var _useState = useState(false),
      personalBookAvailable = _useState[0],
      setPersonalBookAvailable = _useState[1];

  var _useState2 = useState(false),
      isLogin = _useState2[0],
      setIsLogin = _useState2[1];

  var router = useRouter();
  useEffect(function () {
    var isLogin = localStorage.getItem('Counter');
    var token = localStorage.getItem('token');

    if (isLogin && token) {
      setIsLogin(true);
      personalBookAccess(token).then(function (res) {
        // console.log("personal book access res: ", res)
        // if (res.data){
        setPersonalBookAvailable(res.data); // }
      })["catch"](function (err) {
        var _err$response, _err$response2;

        if ((err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.status) === 401 || (err === null || err === void 0 ? void 0 : (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : _err$response2.status) === 403) {
          localStorage.setItem('token', '');
          localStorage.setItem('Username', '');
          localStorage.setItem('Counter', '');
          localStorage.setItem('isLogin', '');
          localStorage.setItem('CellPhoneNum', '');
          router.reload(window.location.pathname);
        } else {
          console.log("Personal book access error:", {
            err: err
          });
        }
      });
    }
  }, []);
  var items = [{
    id: 1,
    title: 'item #2',
    image: "/images/home/landingBannerBlue.svg"
  }, {
    id: 2,
    title: 'item #1',
    image: "/images/home/w-shadow.png"
  }];

  var getPdfButton = function getPdfButton() {
    if (isLogin) {
      if (!(personalBookAvailable !== null && personalBookAvailable !== void 0 && personalBookAvailable.canDownload) && !(personalBookAvailable !== null && personalBookAvailable !== void 0 && personalBookAvailable.countDown)) {
        return /*#__PURE__*/_jsx("div", {
          className: styles.loading,
          children: /*#__PURE__*/_jsx("div", {
            className: "spinner-border text-primary",
            role: "status",
            children: /*#__PURE__*/_jsx("span", {
              className: "sr-only",
              children: "Loading..."
            })
          })
        });
      }

      if (personalBookAvailable !== null && personalBookAvailable !== void 0 && personalBookAvailable.canDownload) {
        return /*#__PURE__*/_jsx("div", {
          className: styles.pdfButton,
          children: /*#__PURE__*/_jsx(MyWordsBook, {
            fromHome: true
          })
        });
      }

      if (personalBookAvailable !== null && personalBookAvailable !== void 0 && personalBookAvailable.countDown) {
        return /*#__PURE__*/_jsxs("div", {
          className: "".concat(styles.noPdf, " ").concat(isRTL ? styles.noPdfFa : ''),
          children: [isRTL ? 'بعد از' : /*#__PURE__*/_jsxs(_Fragment, {
            children: ["You can download ", /*#__PURE__*/_jsx("span", {
              style: {
                fontWeight: 'bold'
              },
              children: "My Word Box"
            }), " after"]
          }), " " + (personalBookAvailable === null || personalBookAvailable === void 0 ? void 0 : personalBookAvailable.countDown) + " ", isRTL ? /*#__PURE__*/_jsxs(_Fragment, {
            children: ["\u0628\u0627\u0632\u06CC \u062F\u06CC\u06AF\u0631 \u0645\u06CC\u200C\u062A\u0648\u0627\u0646\u06CC\u062F ", /*#__PURE__*/_jsx("span", {
              style: {
                fontWeight: 'bold'
              },
              children: "\u0635\u0646\u062F\u0648\u0642\u0686\u0647 \u0648\u0627\u0698\u06AF\u0627\u0646"
            }), " \u062E\u0648\u062F \u0631\u0627 \u062F\u0627\u0646\u0644\u0648\u062F \u06A9\u0646\u06CC\u062F"]
          }) : 'more games']
        });
      }
    } else {
      return /*#__PURE__*/_jsx("div", {
        className: "".concat(styles.noPdfButton, " ").concat(isRTL ? styles.noPdfButtonFa : ''),
        children: isRTL ? /*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx("span", {
            style: {
              fontWeight: 'bold'
            },
            children: "\u0635\u0646\u062F\u0648\u0642\u0686\u0647 \u0648\u0627\u0698\u06AF\u0627\u0646 "
          }), "\u062E\u0648\u062F \u0631\u0627 \u067E\u0633 \u0627\u0632 \u0647\u0631 5 \u0628\u0627\u0631 \u0628\u0627\u0632\u06CC \u062F\u0627\u0646\u0644\u0648\u062F \u06A9\u0646\u06CC\u062F "]
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: ["Download ", /*#__PURE__*/_jsx("span", {
            className: styles.bold,
            children: "My Word Box"
          }), " every 5 games you play"]
        })
      });
    }
  };

  return /*#__PURE__*/_jsx("div", {
    className: styles.wrapper,
    children: /*#__PURE__*/_jsxs("div", {
      className: "".concat(styles.container, " ").concat(isRTL ? styles.rtl : ''),
      children: [/*#__PURE__*/_jsxs("div", {
        className: "d-flex flex-column ".concat(isRTL ? '' : styles.justify, " ").concat([styles.headerPad, isRTL ? styles.headerPadFa : ''].join(' ')),
        children: [/*#__PURE__*/_jsx("img", {
          className: styles.headerLogo,
          src: "/images/logo white.png"
        }), /*#__PURE__*/_jsx("h1", {
          className: styles.topHeader,
          children: t('home:worldOfWords')
        }), /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsxs("h1", {
            className: "".concat(styles.number, " ").concat(isRTL ? styles.farsiTitle : ""),
            children: [isRTL ? "با" : "Compete with", " ", totalUsersNumber ? totalUsersNumber : "88374", " ", isRTL ? "زبان‌آموز دیگر رقابت کنید" : "English learners"]
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "".concat(styles.btnWrapper, " ").concat(styles.inviteButtons),
          style: {
            overflow: 'hidden'
          },
          children: [/*#__PURE__*/_jsx("a", {
            className: styles.btn,
            target: "_blank",
            href: "https://wow.kanoon.ir/appFile/wow.apk",
            children: /*#__PURE__*/_jsx("img", {
              className: "w-100",
              src: "/images/home/wow.png"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: styles.space
          }), /*#__PURE__*/_jsx("a", {
            className: styles.btn,
            target: "_blank",
            href: "https://cafebazaar.ir/app/com.wowDemo.wowApplication?l=en",
            children: /*#__PURE__*/_jsx("img", {
              className: "w-100",
              src: "/images/home/bazaar.png"
            })
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.mobiles,
        children: /*#__PURE__*/_jsx(Carousel, {
          showArrows: false,
          children: items.map(function (item) {
            return /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx("img", {
                className: styles.carouselImage,
                src: item.image,
                alt: ""
              }), item.id === 1 && getPdfButton()]
            }, item.id);
          })
        })
      }), /*#__PURE__*/_jsx("a", {
        className: styles.linkWrapper1,
        target: "_blank",
        href: "https://cafebazaar.ir/app/com.wowDemo.wowApplication?l=en",
        children: /*#__PURE__*/_jsx("img", {
          src: "/images/home/bazaar.png",
          className: "".concat(styles.mobileInviteButton)
        })
      }), /*#__PURE__*/_jsx("a", {
        className: styles.linkWrapper2,
        target: "_blank",
        href: "https://wow.kanoon.ir/appFile/wow.apk",
        children: /*#__PURE__*/_jsx("img", {
          src: "/images/home/wow.png",
          className: "".concat(styles.mobileInviteButton2)
        })
      })]
    })
  });
};

export default Header;